import * as React from 'react';
import {
  BaSeInput,
  BaSeSelect,
  BaSeTextArea,
  BaSeToggler,
  BaSeTheme,
  BaSeParagraph,
  BaSeGrid,
  BaSeGridItem,
} from '@base/react';
import { Ativo } from '../create-form-styled';
import { useBreakpoint } from '../../../hooks/breakpoints';

const limitLength = (max) => (val) => val.slice(0, max);

export const BasicInfoSection = ({
  formData,
  typeProducts,
  isUpdate,
  uiState,
  onFieldChange,
  selectedProductTypeId,
  onSearchPortfolio,
  // eslint-disable-next-line
}) => {
  const { isDesktop } = useBreakpoint();

  return (
    <>
      <BaSeGrid>
        <BaSeGridItem size={10}>
          <BaSeSelect
            label="Tipo do produto"
            onChange={(value) => onFieldChange('tipoProduto', value)}
            values={typeProducts}
            selectedValueId={selectedProductTypeId}
            moreInfoLabel={
              uiState.sent &&
              (!formData.tipoProduto || formData.tipoProduto === 'Selecione')
                ? 'O campo Tipo do produto no FOCO é de preenchimento obrigatório'
                : ''
            }
          />
        </BaSeGridItem>
        <BaSeGridItem size={1}>
          <Ativo>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Ativo
            </BaSeParagraph>
          </Ativo>
        </BaSeGridItem>
        <BaSeGridItem size={1}>
          <Ativo>
            <BaSeToggler
              color="default"
              value={formData.ativo}
              onChange={() => onFieldChange('ativo', !formData.ativo)}
              type="outlined"
            />
          </Ativo>
        </BaSeGridItem>
        <BaSeGridItem size={isDesktop() ? 6 : 12}>
          <BaSeInput
            label="Id do Portfólio/Produto no FOCO"
            iconButton={{
              action: onSearchPortfolio,
              name: 'search',
              type: 'primary',
              typeButton: 'base-button',
              value: 'Buscar',
            }}
            value={formData.idPortfolio}
            onChange={(e) => onFieldChange('idPortfolio', e)}
            placeholder="Digite o código do produto no FOCO"
            moreInfoLabel={
              uiState.sent && !formData.idPortfolio
                ? 'O campo Código do produto no FOCO é de preenchimento obrigatório'
                : ''
            }
          />
        </BaSeGridItem>
        <BaSeGridItem size={isDesktop() ? 6 : 12}>
          <BaSeInput
            label="Id de disponibilização no FOCO"
            subLabel="Opcional"
            value={formData.idDisponibilizacao}
            onChange={(e) => onFieldChange('idDisponibilizacao', e)}
            placeholder="Digite o código de disponibilização no FOCO"
          />
        </BaSeGridItem>
        {isUpdate && (
          <>
            <BaSeGridItem size={isDesktop() ? 6 : 12}>
              <BaSeInput
                label="Código do produto no SAS"
                subLabel="Opcional"
                value={formData.codigoProdutoSas}
                onChange={(e) => onFieldChange('codigoProdutoSas', e)}
                placeholder="Digite o código do produto no SAS"
              />
            </BaSeGridItem>
            <BaSeGridItem size={isDesktop() ? 6 : 12}>
              <BaSeInput
                label="Código de disponibilização no SAS"
                subLabel="Opcional"
                value={formData.codigoDisponibilizacaoSas}
                onChange={(e) => onFieldChange('codigoDisponibilizacaoSas', e)}
                placeholder="Digite o código de disponibilização no SAS"
              />
            </BaSeGridItem>
          </>
        )}
      </BaSeGrid>
      <BaSeInput
        label="Nome do produto"
        value={formData.nome}
        onChange={(e) => onFieldChange('nome', e)}
        moreInfoLabel={
          uiState.sent && !formData.nome
            ? 'O campo Nome do produto é de preenchimento obrigatório'
            : ''
        }
      />
      <BaSeTextArea
        label="Breve descrição"
        subLabel="Opcional"
        maxValue={300}
        onChange={(e) => onFieldChange('descricao', e, limitLength(300))}
        placeholder="Digite uma descrição pública para esse produto."
        rows={3}
        textSize="medium"
        value={formData.descricao}
      />
    </>
  );
};
